import { render } from "./Credentials.vue?vue&type=template&id=0cf6c55c"
import script from "./Credentials.vue?vue&type=script&lang=js"
export * from "./Credentials.vue?vue&type=script&lang=js"

import "./Credentials.vue?vue&type=style&index=0&id=0cf6c55c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__